import type { CityConfig } from "../city-template/types";

export const viennaVaConfig: CityConfig = {
  city: "Vienna",
  state: "Virginia",
  stateAbbr: "VA",
  slug: "vienna-va",
  route: "/cities/vienna-va",
  title: "Emergency Passport Vienna, VA — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Vienna, VA — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Vienna, Fairfax, McLean, Tysons, Oakton, and all of Northern Virginia. Get your passport fast!",
  h1: "Emergency & Expedited Passport Services in Vienna, VA",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Vienna and Northern Virginia travelers — including residents of charming historic Vienna, the town voted one of America's best small towns — get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Beautiful Vienna Virginia downtown townscape at golden hour with charming historic buildings along Church Street, the iconic Vienna Town Green with trees, the W&OD Trail visible, warm amber and golden sunset light, cozy small-town atmosphere with brick sidewalks and mature trees, professional photography with rich warm colors and clean architectural detail, no people visible, quintessential American small town beauty near Washington DC suburbs&width=1800&height=700&seq=vienna-va-hero-001&orientation=landscape",
  heroImageAlt: "Historic Vienna Virginia downtown with charming Church Street buildings and the Town Green at golden hour",
  geoPosition: "38.9012;-77.2652",
  geoPlacename: "Vienna, Virginia",
  regionalAgency: {
    name: "Washington Passport Agency",
    address: "600 19th Street NW, Washington, DC 20006",
    distance: "Located in downtown Washington, DC — approximately 16 miles from Vienna via I-66",
  },
  nearbyCitiesZips: [
    { name: "Vienna", zips: "22180, 22181, 22182" },
    { name: "Vienna Town Center", zips: "22180" },
    { name: "West Vienna", zips: "22181" },
    { name: "Fairfax", zips: "22030, 22031, 22032, 22033" },
    { name: "Fairfax City", zips: "22030, 22031" },
    { name: "Oakton", zips: "22124" },
    { name: "McLean", zips: "22101, 22102" },
    { name: "Tysons Corner", zips: "22102" },
    { name: "Centreville", zips: "20120, 20121" },
    { name: "Chantilly", zips: "20151, 20152" },
    { name: "Burke", zips: "22015" },
    { name: "Springfield", zips: "22150–22153" },
    { name: "Annandale", zips: "22003" },
    { name: "Falls Church", zips: "22040–22046" },
    { name: "Merrifield", zips: "22116" },
    { name: "Dunn Loring", zips: "22027" },
    { name: "Reston", zips: "20190–20194" },
    { name: "Herndon", zips: "20170–20172" },
    { name: "Sterling", zips: "20164, 20165" },
    { name: "Ashburn", zips: "20147, 20148" },
    { name: "Leesburg", zips: "20175, 20176" },
    { name: "Manassas", zips: "20110, 20111" },
    { name: "Woodbridge", zips: "22191, 22192, 22193" },
    { name: "Arlington", zips: "22201–22217" },
    { name: "Alexandria", zips: "22301–22315" },
    { name: "Richmond", zips: "23218–23242" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Vienna departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "NoVA Hub", desc: "Serving Vienna, Fairfax, McLean, Tysons, and all of Northern Virginia" },
  ],
  internalLinks: [
    { name: "Virginia state passport services", route: "/states/virginia" },
    { name: "Fairfax VA passport services", route: "/cities/fairfax-va" },
    { name: "McLean VA passport services", route: "/cities/mclean-va" },
    { name: "Arlington VA passport services", route: "/cities/arlington-va" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Vienna remotely via secure courier. We do not have a walk-in office in Vienna — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Vienna and Northern Virginia travelers.",
  fpcOfficeAddress: "1629 K St NW #300, Washington, DC 20006",
  fpcOfficeDistance: "Serving all of Vienna and the surrounding Northern Virginia area including Fairfax, McLean, Tysons Corner, Oakton, Centreville, Chantilly, Burke, Springfield, Annandale, Falls Church, and all of Fairfax County",
  serviceAreaIntro: "From the historic charm of Vienna Town Center to the growing corridors of West Vienna, from the bustling energy of nearby Tysons Corner to the peaceful neighborhoods of Oakton — Fast Passport Center serves every corner of Vienna and Northern Virginia. We regularly help travelers from McLean, Fairfax, Falls Church, and the broader Fairfax County area get their passports fast.",
  nearbyCitiesIntro: "We serve all Vienna neighborhoods and the surrounding Northern Virginia metro area including Fairfax, Fairfax City, McLean, Tysons Corner, Oakton, Centreville, Chantilly, Burke, Springfield, Annandale, Falls Church, Merrifield, Dunn Loring, Reston, Herndon, Sterling, Ashburn, Leesburg, Manassas, Woodbridge, Arlington, and Alexandria. If you are anywhere in the Vienna or Northern Virginia region, we have you covered.",
  howItWorksIntro: "Most Vienna travelers complete everything online and ship documents overnight. No need to drive into Washington, DC or wait in line at the regional agency.",
  mistakesIntro: "Vienna travelers often face the temptation to drive to the Washington regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Vienna and Northern Virginia travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Vienna? Here are the most common ones we hear from Northern Virginia travelers.",
  statePageRoute: "/states/virginia",
  statePageName: "Virginia",
  dmvWebsite: "https://www.dmv.virginia.gov",
  dmvLabel: "Virginia DMV — Official Website",
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    { icon: "ri-user-smile-line", label: "Birth Certificate", desc: "Request certified birth certificates from Virginia Department of Health Vital Records. Online, mail, or in-person options available for Vienna and Fairfax County residents.", url: "https://www.vdh.virginia.gov/vital-records/" },
    { icon: "ri-file-list-2-line", label: "Death Certificate", desc: "Obtain certified death certificates through Virginia Department of Health Vital Records. Required for estate, insurance, and legal matters.", url: "https://www.vdh.virginia.gov/vital-records/" },
    { icon: "ri-hearts-line", label: "Marriage Certificate", desc: "Request marriage license records from the Fairfax County Circuit Court Clerk. Certified copies available for name changes and legal purposes.", url: "https://www.fairfaxcounty.gov/" },
    { icon: "ri-file-copy-line", label: "Divorce Decree", desc: "Obtain certified divorce records through the Fairfax County Circuit Court Clerk. Required for name change passport corrections.", url: "https://www.fairfaxcounty.gov/" },
  ],
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Vienna international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Jennifer L.",
      location: "Vienna, VA",
      rating: 5,
      text: "My passport expired three weeks before my trip to Italy. Fast Passport Center had my renewal processed in 4 days. I shipped from the Vienna UPS on Maple Avenue and never had to leave town. Incredible service.",
      service: "Passport Renewal",
    },
    {
      name: "David R.",
      location: "Tysons Corner, near Vienna, VA",
      rating: 5,
      text: "Emergency passport for a last-minute business trip to London. I was facing a deadline that could have cost me a major client. Fast Passport Center delivered in 36 hours. Their Vienna-area team knew exactly what I needed.",
      service: "Emergency Passport",
    },
    {
      name: "Maria S.",
      location: "Oakton, near Vienna, VA",
      rating: 5,
      text: "First passports for my twin daughters before our family trip to Costa Rica. Fast Passport Center handled the parental consent requirements perfectly and had both passports in 5 days. The Vienna-area service was outstanding.",
      service: "Child Passport",
    },
    {
      name: "Robert K.",
      location: "McLean, near Vienna, VA",
      rating: 5,
      text: "Lost my passport 72 hours before a flight to Tokyo for a tech conference. I was absolutely panicking. Fast Passport Center had a replacement in my hands in 28 hours. They saved a major client presentation.",
      service: "Lost Passport",
    },
  ],
  facilities: [
    {
      id: "vienna-va-1",
      name: "Vienna Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "200 Lawyers Rd NW",
      city: "Vienna",
      state: "VA",
      zip: "22180",
      phone: "(703) 938-3551",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Vienna Town Center, near Church Street",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Vienna facility. Full passport services with appointment. Serves Vienna and east Fairfax area. Call ahead to confirm.",
      icon: "ri-mail-line",
    },
    {
      id: "vienna-va-2",
      name: "Fairfax Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "4000 Chain Bridge Rd",
      city: "Fairfax",
      state: "VA",
      zip: "22030",
      phone: "(703) 359-4276",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Fairfax, approximately 5 miles south",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Major Fairfax County facility. Full passport services with appointment. Convenient for Vienna residents.",
      icon: "ri-mail-line",
    },
    {
      id: "vienna-va-3",
      name: "Fairfax County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "4110 Chain Bridge Rd",
      city: "Fairfax",
      state: "VA",
      zip: "22030",
      phone: "(703) 691-7320",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Fairfax County Government Center, approximately 5 miles south",
      website: "https://www.fairfaxcounty.gov/",
      websiteLabel: "Fairfax County Clerk",
      notes: "Major county facility for Fairfax County. Accepts walk-ins but appointments recommended for faster service.",
      icon: "ri-government-line",
    },
    {
      id: "vienna-va-4",
      name: "McLean Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1498 Chain Bridge Rd",
      city: "McLean",
      state: "VA",
      zip: "22101",
      phone: "(703) 356-1545",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "McLean, approximately 6 miles east",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves McLean and east Vienna area. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "vienna-va-5",
      name: "Springfield Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "7201 Old Keene Mill Rd",
      city: "Springfield",
      state: "VA",
      zip: "22150",
      phone: "(703) 455-7626",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Springfield, approximately 10 miles south",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Springfield and south Vienna area. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "vienna-va-6",
      name: "Chantilly Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "14004 Thunderbolt Pl",
      city: "Chantilly",
      state: "VA",
      zip: "20151",
      phone: "(703) 378-1145",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Chantilly, approximately 12 miles west",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Chantilly and northwest Vienna area. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — drive into downtown DC", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
    { feature: "Military & Government", agency: "No special handling", fpc: "Yes — priority for military and government travelers" },
    { feature: "Multi-Application Households", agency: "One slot per application", fpc: "Yes — family batch processing supported" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Vienna photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Northern Virginia acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Vienna applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Washington DC regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Vienna families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Vienna travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Vienna or Fairfax." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Vienna address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Vienna before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Vienna for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the drive into downtown Washington, DC." },
    { q: "How fast can I renew my passport in Vienna?", a: "Fast Passport Center offers fast passport renewal in Vienna in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Vienna?", a: "The nearest regional passport agency to Vienna is the Washington Passport Agency, located approximately 16 miles away in downtown Washington, DC. For urgent processing without navigating DC traffic and parking, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Vienna without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near Vienna?", a: "Same-day passport appointments are only available at the Washington Regional Passport Agency for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Vienna residents." },
    { q: "Can I expedite a child passport in Vienna?", a: "Yes. Fast Passport Center expedites child passports in Vienna for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Vienna families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Vienna with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "How fast can I get a passport in Vienna?", a: "With Fast Passport Center's emergency courier service, Vienna travelers can receive their passport in as little as 24–48 hours. Our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities, bypassing standard mail delays." },
    { q: "Do I need to drive to the Washington Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
    { q: "Where are the closest passport acceptance facilities near Vienna?", a: "Popular options include the Vienna Post Office (22180), Fairfax Main Post Office (22030), Fairfax County Clerk (22030), McLean Post Office (22101), Springfield Post Office (22150), and Chantilly Post Office (20151). All require appointments. We help you find the most convenient location and schedule your visit." },
    { q: "Can I get a same-day passport in Vienna?", a: "Same-day passports are only available at the Washington Regional Passport Agency for documented life-or-death emergencies with proof of travel within 72 hours. For all other urgent travel, Fast Passport Center's 24–48 hour emergency processing is the fastest reliable option — without the DC traffic and parking hassle." },
    { q: "What if I live in a smaller Vienna area neighborhood?", a: "We serve the entire Vienna and Northern Virginia region including Vienna Town Center, West Vienna, Fairfax, Fairfax City, Oakton, McLean, Tysons Corner, Centreville, Chantilly, Burke, Springfield, Annandale, Falls Church, Merrifield, Dunn Loring, Reston, Herndon, Sterling, and Ashburn. Our overnight shipping labels work from any UPS location, so your location doesn't affect processing speed." },
    { q: "How much does expedited passport service cost in Vienna?", a: "Government fees are fixed: $130 for a passport book (adult) plus a $60 expedite fee. Fast Passport Center's service fees vary by processing speed — emergency 24–48 hour processing, 3–5 day expedited, or standard options. Contact us for a personalized quote based on your timeline." },
    { q: "Do you help with passport photos in Vienna?", a: "We guide you on exact photo requirements and can recommend locations near you. Many CVS, Walgreens, and FedEx Office locations in Vienna, Fairfax, and McLean offer passport photo services. We review your photos before submission to ensure they meet State Department standards." },
    { q: "What documents do I need for a first-time passport in Vienna?", a: "You'll need proof of citizenship (birth certificate or naturalization certificate), government-issued photo ID (driver's license or REAL ID), two passport photos, and payment. We provide a complete checklist and review your documents before you visit the acceptance clerk." },
    { q: "Can you help with a child's passport in Vienna?", a: "Yes. Child passports require both parents (or notarized consent from the absent parent), the child's birth certificate, and both parents' IDs. We walk Vienna families through the entire process and help schedule acceptance clerk appointments." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Vienna", address: "212 Maple Ave E, Vienna, VA 22180", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Vienna", address: "301 Maple Ave E, Vienna, VA 22180", hours: "Mon–Sun: 7AM–11PM" },
    { name: "FedEx Office — Vienna", address: "225 Maple Ave W, Vienna, VA 22180", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
    { name: "CVS Pharmacy — Fairfax", address: "10560 Main St, Fairfax, VA 22030", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Fairfax", address: "13050 Lee Jackson Memorial Hwy, Fairfax, VA 22033", hours: "Mon–Sun: 7AM–11PM" },
    { name: "FedEx Office — McLean", address: "1430 Dolley Madison Blvd, McLean, VA 22101", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
    { name: "CVS Pharmacy — Springfield", address: "6400 Springfield Plaza, Springfield, VA 22150", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Oakton", address: "2956 Chain Bridge Rd, Oakton, VA 22124", hours: "Mon–Sun: 7AM–11PM" },
  ],
  dmvLocations: [
    {
      name: "Virginia DMV — Fairfax",
      address: "4110 Chain Bridge Rd, Fairfax, VA 22030",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver's license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "Virginia DMV — Tysons",
      address: "1960 Chain Bridge Rd, Tysons, VA 22102",
      hours: "Mon–Fri: 8AM–5PM",
      note: "REAL ID and passport-related ID services. Appointment strongly recommended.",
      featured: false,
    },
    {
      name: "Virginia DMV — Springfield",
      address: "7764 Gunston Plaza, Springfield, VA 22153",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Springfield and south Vienna residents. REAL ID available.",
      featured: false,
    },
    {
      name: "Virginia DMV — Chantilly",
      address: "4410 Stampede Rd, Chantilly, VA 20151",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves west Vienna and Chantilly area. REAL ID available.",
      featured: true,
    },
  ],
  airports: [
    {
      code: "IAD",
      name: "Dulles International Airport",
      distance: "12 miles west of Vienna",
      address: "1 Saarinen Cir, Dulles, VA 20166",
      note: "The primary international airport for Vienna and Northern Virginia. Major hub for long-haul flights to Europe, Asia, and the Caribbean. Accessible via Route 7 and Dulles Toll Road.",
      flightUrl: "https://www.flydulles.com/",
      flightLabel: "IAD Airport",
      featured: true,
    },
    {
      code: "DCA",
      name: "Ronald Reagan Washington National Airport",
      distance: "16 miles southeast of Vienna",
      address: "2401 Smith Ave, Arlington, VA 22202",
      note: "Alternative major airport for domestic flights and international connections. Accessible via I-66 and GW Parkway.",
      flightUrl: "https://www.flyreagan.com/",
      flightLabel: "DCA Airport",
      featured: false,
    },
    {
      code: "BWI",
      name: "Baltimore/Washington International Airport",
      distance: "55 miles northeast of Vienna",
      address: "7050 Friendship Rd, Baltimore, MD 21240",
      note: "Alternative international hub for international flights. Accessible via I-95.",
      flightUrl: "https://www.bwiairport.com/",
      flightLabel: "BWI Airport",
      featured: false,
    },
  ],
};